import { Box, BoxProps, Button, Text, TextProps } from 'grommet';
import { IconProps } from 'grommet-icons';
import { ReactNode } from 'react';

export type IconButtonProps = {
  icon: ReactNode;
  onClick: () => void;
  size?: IconProps['size'];
  color?: IconProps['color'];
  pad?: BoxProps['pad'];
  text?: string;
  textProps?: TextProps;
};

export const IconButton = ({
  icon,
  onClick,
  color = 'brand',
  pad = 'small',
  text,
  textProps,
}: IconButtonProps) => {
  return (
    <Box align="center">
      <Button
        onClick={onClick}
        icon={<Box pad={pad}>{icon}</Box>}
        plain={false}
        style={{ borderRadius: '50%', borderWidth: '4px', borderColor: color }}
      />
      <Text {...textProps}>{text}</Text>
    </Box>
  );
};
